export default __webpack_public_path__ + "static/media/Logo.e575a607.jpg";